import { render } from "./App.vue?vue&type=template&id=cb3e4e88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cb3e4e88&lang=css"
script.render = render

export default script